import React from 'react';
import { Box, CircularProgress, Typography, keyframes } from '@mui/material';
import { Bolt as FlashIcon } from '@mui/icons-material';
import InstaQuizShell from './InstaQuizShell';
import { INSTA_QUIZ } from './instaQuizTheme';

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.06); opacity: 1; }
`;

const spinGlow = keyframes`
  0% { box-shadow: 0 0 20px rgba(156,39,176,0.4); }
  50% { box-shadow: 0 0 40px rgba(224,64,251,0.6); }
  100% { box-shadow: 0 0 20px rgba(156,39,176,0.4); }
`;

const STATUS_COPY = {
  checking: {
    title: 'Tuning into the live vibe…',
    subtitle: "Hang tight — we're scanning for an active Insta Quiz round just for you.",
  },
  joining: {
    title: 'Almost on stage!',
    subtitle: "We're saving your spot on the leaderboard. Get ready to shine.",
  },
};

const InstaQuizStatusScreen = ({ variant = 'checking', onBack }) => {
  const copy = STATUS_COPY[variant] || STATUS_COPY.checking;

  return (
    <InstaQuizShell onBack={onBack} showHeader={!!onBack} title="Insta Quiz">
      <Box sx={{ textAlign: 'center', maxWidth: 420 }}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 100,
            height: 100,
            borderRadius: '50%',
            mb: 3,
            background: 'linear-gradient(135deg, rgba(156,39,176,0.3) 0%, rgba(224,64,251,0.2) 100%)',
            border: `2px solid ${INSTA_QUIZ.cardBorder}`,
            animation: `${pulse} 2s ease-in-out infinite, ${spinGlow} 2.5s ease-in-out infinite`,
          }}
        >
          <FlashIcon sx={{ fontSize: 48, color: INSTA_QUIZ.purpleLight }} />
        </Box>

        <CircularProgress
          size={44}
          thickness={3}
          sx={{ color: INSTA_QUIZ.purple, mb: 3 }}
        />

        <Typography
          variant="h5"
          sx={{
            color: '#fff',
            fontWeight: 700,
            mb: 1.5,
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
          }}
        >
          {copy.title}
        </Typography>
        <Typography variant="body1" sx={{ color: INSTA_QUIZ.textMuted, lineHeight: 1.7 }}>
          {copy.subtitle}
        </Typography>
      </Box>
    </InstaQuizShell>
  );
};

export default InstaQuizStatusScreen;
